import React, { useEffect, useState } from 'react';

export const RainingTools = () => {
  const [tools, setTools] = useState([]);

  const toolIcons = [
    '🔧', '🔨', '🪛', '🧹', '🧽', '🍳', '👶', '🐕', '📚', 
    '🌱', '💪', '💄', '✂️', '🎨', '🧴', '🪣', '🧯', '⚡'
  ];

  useEffect(() => {
    const createTool = () => {
      const tool = {
        id: Math.random(),
        icon: toolIcons[Math.floor(Math.random() * toolIcons.length)],
        left: Math.random() * 100,
        animationDuration: 3 + Math.random() * 4, // 3-7 seconds
        delay: Math.random() * 2
      };
      return tool;
    };

    // Create initial tools
    const initialTools = Array.from({ length: 8 }, createTool);
    setTools(initialTools);

    // Add new tools periodically
    const interval = setInterval(() => {
      setTools(currentTools => {
        // Remove tools that are too old
        const filteredTools = currentTools.filter(tool => 
          Date.now() - tool.createdAt < 8000
        );
        
        // Add new tool occasionally
        if (Math.random() < 0.3) {
          const newTool = {
            ...createTool(),
            createdAt: Date.now()
          };
          return [...filteredTools, newTool];
        }
        
        return filteredTools;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
      {tools.map(tool => (
        <div
          key={tool.id}
          className="absolute text-2xl opacity-30 animate-bounce"
          style={{
            left: `${tool.left}%`,
            top: '-50px',
            animationDuration: `${tool.animationDuration}s`,
            animationDelay: `${tool.delay}s`,
            transform: 'translateY(100vh)'
          }}
        >
          {tool.icon}
        </div>
      ))}
      
      <style jsx>{`
        @keyframes fall {
          0% {
            transform: translateY(-50px) rotate(0deg);
            opacity: 0.7;
          }
          50% {
            opacity: 0.3;
          }
          100% {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0;
          }
        }
        
        .animate-fall {
          animation: fall linear forwards;
        }
      `}</style>
    </div>
  );
};

export const ColorfulBackground = ({ children }) => {
  return (
    <div className="relative min-h-screen" style={{ background: 'linear-gradient(135deg, #FFECD1 0%, #FCB69F 50%, #FFAAA5 100%)' }}>
      <RainingTools />
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};